module.exports = __webpack_public_path__ + "media/images/web/home/index/specs/custom-1a2a7b021a972e98fa5865c59c0abecb.svg";